import React, { useEffect, useState } from 'react';
import DashboardPagesTemplate from '../../../components/DashboardPagesTemplate/DashboardPagesTemplate';
import { FaEllipsisH, FaPlusCircle } from 'react-icons/fa';
import { ColumnSettlements, SettlementsData } from '../../../types/TablesTypes/Settlements';
import client from '../../../api/client';
import showToast from '../../../components/CustomToast/toastHelper';
import { numberWithCommas } from '../../../utils/formatNumber';
import StatusView from '../../../components/StatusView/StatusView';
import { Dropdown } from 'flowbite-react';
import { useCurrency } from '../../../contexts/CurrencyContext';

const Settlements = () => {
  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: ''
  });

  const [settlements, setSettlements] = useState<any>(null);
  const [tableRow, setTableRow] = useState<SettlementsData[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(true);
  const {currency} = useCurrency()
  const [isExport, setIsExport] = useState<boolean>(false)
  const [isExportReady, setIsExportReady] = useState<boolean>(false); 
  const [isExportLoading, setIsExportLoading] = useState<boolean>(false);

  const clickExport = async () => {
    setIsExport(true);
    setIsExportLoading(true)
    await fetchSettlements(); 

    if (settlements && settlements.items?.length > 0) {
        setIsExportReady(true); 
    }

    setIsExportLoading(false); 
};


  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      await fetchSettlements();
      setLoading(false)
    };
    fetchData();
  }, [filters,currency, currentPage]);

  const fetchSettlements = async () => {
    try {
      const apiUrl = `/subsidiary/dashboard/settlement/paginated`;
      const params = new URLSearchParams({
        ...filters
      }).toString();
      const response = await client.get(`${apiUrl}?${params}&Export=${true}`);

      setSettlements(response.data.data);
      setTotalPages(response.data.data.page.totalPage);
      setTableRow(dataTransaction());
    } catch (err: any) {
      if (err?.response?.data?.message === 'Please login again') {
        sessionStorage.clear();
        window.location.href = '/';
      } else {
        const message = err?.response?.data?.message;
        console.error('Error getting data', err);
        showToast(message, "error");
      }
    }
  };

  const dataTransaction = () => {
    const tempArr: SettlementsData[] = [];
    settlements?.items
      ?.slice(0)
      .reverse()
      .forEach((settlement: any) => {
        tempArr.push({
          subsidiaryName: settlement?.subsidiaryName,
          transactionAmount: `${settlement?.currency} ${numberWithCommas(settlement?.transactionAmount)}`,
          fee: `${settlement?.currency} ${numberWithCommas(settlement?.fee)}`,
          currency: `${(settlement?.currency).toUpperCase()}`,
          settlementStatus: (
            <StatusView
              status={settlement?.settlementStatus}
              green='Completed'
              orange='Pending'
            />
          ),
          action: (
            <Dropdown label={<FaEllipsisH />} inline arrowIcon={false} placement='right-start'>
              {/* Add dropdown items here */}
            </Dropdown>
          ),
        });
      });
    return tempArr;
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  useEffect(()=>{
    setTableRow(dataTransaction())
  },[settlements?.items])

  return (
    <div>
      <DashboardPagesTemplate
        apiUrl='/subsidiary/dashboard/settlement/paginated'
        title='Settlements'
        onFilterChange={setFilters}
        headings={ColumnSettlements}
        exportButtonExists={true}
        data={tableRow}
        ctaButtonExists={false}
        buttonLabel='Create Virtual Account'
        buttonIcon={<FaPlusCircle />}
        showSearch={false}
        filters={filters}
        dropdownItems={["All","Completed", "Pending"]}
        datepickerExists={true}
        emptyMessage={`You currently do not have any settlements in ${currency}`}
        statusKey='settlementstatus'
        loading={loading}
        dataToExport={isExportReady ? settlements?.items : []}
        clickExportButton={clickExport}
        exportButtonLoading={isExportLoading}
        exportButtonClicked={isExport}
      />
    </div>
  );
};

export default Settlements;
